import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GalleryLayout10 } from '@components/gallery/components/gallery-layout-10/model';
import { ImageComponent } from '@shared/components/image';
import { QuoteComponent } from '@shared/components/quote';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: 'app-gallery-layout-10',
  imports: [NgTemplateOutlet, QuoteComponent, ImageComponent, VideoComponent],
  templateUrl: './gallery-layout-10.component.html',
  styleUrl: './gallery-layout-10.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout10Component {
  readonly data = input.required<GalleryLayout10>();
}
